import styled from 'styled-components';
import { Popover } from "../Popover/Popover";
export var popoverDesktopMinWidth = '180px';
export var PopoverDesktop = styled(Popover).withConfig({
  displayName: "PopoverDesktop",
  componentId: "sc-1q89gj7-0"
})(["min-width:", ";"], popoverDesktopMinWidth);